import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}devrienden/`;

const title = "Holy Road - Friends";
const description = "This story, a piece of reporting of which we were extremely proud, is no longer available. The reason for this is that the boys have withdrawn their cooperation out of fear of threats.";
const featuredImage = `${imageFolder}devrienden/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}devrienden`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}djv201703101027.jpg`,
            tablet: `${imageFolder}djv201703101027.jpg`,
            desktop: `${imageFolder}djv201703101027.jpg`,
            alt: "",
            text: "Jenin Refugee in 2017"
        }
    },
    {
      type: "Paragraph",
      text: "This page originally contained a story of hope; a genuine feel-good story about five Palestinian boys who had made good despite growing up surrounded by violence in the Jenin refugee camp in the West Bank. Dirk-Jan Visser first photographed the boys during the height of the Second Intifada (uprising) in the early 2000s and again in 2017. The ‘then and now’ photos of the five elicited the necessary emotions from everyone who saw them."
    },
    {
      type: "Paragraph",
      text: "The Holy Road aims to offer a glimpse into daily life in the West Bank, for both Palestinians and the Jewish settlers. Whatever you may think of their political views, the settlers also experience human tragedy, which we also wanted to report. See, for example, the story of 13-year old Hallel Yaffe Ariel, who was stabbed to death in her own bedroom by a Palestinian."
    },
    {
      type: "Paragraph",
      text: "We believe we were always totally clear about what we wanted to achieve with The Holy Road. Nevertheless, at the beginning of 2018, when the English translation of the documentary appeared, our contact person for the Jenin refugee camp was apparently shocked that Jewish settlers were also featured. This is unacceptable for some Palestinians; ‘collaborating’ with the occupier on a production could contribute to the ‘normalisation’ of the occupation. This group believes that the 50-year military repression of Palestinians in the West Bank is anything but normal and that acting as if it were should be avoided at all costs."
    },
    {
      type: "Paragraph",
      text: "The contact person showed the boys the documentary and they demanded that we remove their story. Their argument was that both the contact person and the boys could be seen as traitors or collaborators because their participation was normalising the occupation."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}161223000063660057.jpg`,
            tablet: `${imageFolder}161223000063660057.jpg`,
            desktop: `${imageFolder}161223000063660057.jpg`,
            alt: "",
            text: "Jenin refugee camp in 2002."
        }
    },
    {
      type: "Paragraph",
      text: "From a journalistic standpoint, we do not regard this as a valid argument. We have not made a pro-Palestinian or anti-Israeli propaganda film; we are simply showing the reality for both groups. What does worry us is the argument that the boys could be threatened. That’s why we decided to tell this new story addressing the difficult questions surrounding normalisation, the boycott movement against Israel and the internal Palestinian pressure on people to conform to these norms. The pressure applied on the boys not to collaborate with normalisation is far from being an isolated incident: the municipality of Ramallah cancelled the screening of the Oscar-nominated Lebanese film The Insult due to the fact that director Ziad Doueiri had spent a few weeks in Tel Aviv while shooting a previous film."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/01Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/01Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/01Jenin.jpg`,
                alt: "",
                text: "The Jenin refugee camp, a few days after operation 'Defensive Shield'."
            },
            {
                mobile: `${imageFolder}slideshow1/02Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/02Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/02Jenin.jpg`,
                alt: "",
                text: "Everywhere people are sitting helplessly on the ruins of their house."
            },
            {
                mobile: `${imageFolder}slideshow1/03Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/03Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/03Jenin.jpg`,
                alt: "",
                text: "In a circle around the flattened part of the camp all the houses are badly damaged."
            },
            {
                mobile: `${imageFolder}slideshow1/04Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/04Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/04Jenin.jpg`,
                alt: "",
                text: "Aid organizations have brought water and food for the victims."
            },
            {
                mobile: `${imageFolder}slideshow1/05Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/05Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/05Jenin.jpg`,
                alt: "",
                text: "An old man is lost in thought by his ruined house."
            },
            {
                mobile: `${imageFolder}slideshow1/06Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/06Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/06Jenin.jpg`,
                alt: "",
                text: "Whole families spend days on the ruins of their houses."
            },
            {
                mobile: `${imageFolder}slideshow1/07Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/07Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/07Jenin.jpg`,
                alt: "",
                text: "A boy climbs on the roof of his damaged house."
            },
            {
                mobile: `${imageFolder}slideshow1/08Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/08Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/08Jenin.jpg`,
                alt: "",
                text: "Old women oversee the arrival of journalists and aid workers to the destroyed Jenin refugee camp."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "The call for a cultural boycott of Israel is part of the Boycott, Divestment and Sanctions (BDS) movement that was founded by Palestinian activists in 2004. In the previous decades, two bloody intifadas had claimed thousands of lives, without the Palestinians making any political progress. The time had come for non-violent resistance, the activists believed, hoping to bring an end to the Israeli occupation and discrimination against Palestinians. They also want Israel to recognise Palestinian refugees’ right of return. The activists’ tactics reflect the boycott of the South African apartheid regime, which contributed to the regime’s eventual collapse. A number of high-profile figures support the BDS movement, including scientist Stephen Hawking, who died in March 2018, writer Naomi Klein and archbishop Desmond Tutu."
    },
    {
      type: "Paragraph",
      text: "There are varying ideas within the movement as to exactly who and what should be boycotted. Some say they are against the occupation, so they do not buy products made in the illegal Jewish settlements in the West Bank. Others do not buy any Israeli products because they believe that in order to end the occupation, pressure should be exerted on the whole of Israel. This second group also wants to boycott Israeli universities while others disagree, arguing that Israeli academics are just the people they need for resistance on the inside."
    },
    {
      type: "Paragraph",
      text: "BDS activists are best known for disrupting performances and calling on artists not to perform in Israel. They believe that as long as the military occupation of Palestinian territory continues, artists should avoid Israel. Big names such as Radiohead and Britney Spears have been targeted. Occasionally the activists achieve a victory, as when New Zealand singer Lorde cancelled her show in Tel Aviv in 2017. Every artist who ignores the Palestinian pressure is loudly applauded on social media under the hashtag #BDSFail by pro-Israeli activists. Performing in Israel has become a statement."
    },
    {
      type: "Paragraph",
      text: "A proven BDS method is to pressurise businesses and governments that have dealings with the illegal settlements. Several Dutch businesses have given in to the pressure. In 2014, pension fund PGGM decided to stop investing in five Israeli banks that funded the building of Jewish settlements, and water company Vitens ended its collaboration with the Israeli firm providing the settlements with water."
    },
    {
      type: "Paragraph",
      text: "The economic damage caused by the BDS movement is minimal, however. A 2015 report published by the Knesset, the Israeli parliament, concluded that exports to Europe have actually doubled since 2005, from 7 to 14 billion euros. Even if Europe boycotted all products from the settlements, it would only cost Israel a maximum of 90 million euros annually. In spite of this, Israeli politicians and newspapers, with the exception of the most left-wing, strongly criticise the BDS movement. Prime Minister Benjamin Netanyahu calls the movement ‘anti-Semitic’ and opposition leader Isaac Herzog has even compared the boycott to ‘a new intifada’."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                alt: "",
                text: "Same place in 2002 and in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                alt: "",
                text: "Same place in 2002 and in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                alt: "",
                text: "Same place in 2002 and in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                alt: "",
                text: "Same place in 2002 and in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                alt: "",
                text: "Same place in 2002 and in 2017."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "These strong terms originate partially from Israel’s fear that its position will be jeopardised. Even though most of the international community is against the decades-long occupation, Israel has so far mostly managed to get away with it. Even the continual expansion of the Jewish settlements in the West Bank provokes barely any response from the international community. However, if the BDS movement manages to sensitise the Western public to the illegality of the occupation, Israel will have a problem. Another reason to come down hard on the BDS movement is internal politics: Israelis vote for politicians who demonstrate that they will go to any lengths to defend their country."
    },
    {
      type: "Paragraph",
      text: "Israel spends huge sums of money – 30 million euros in 2016 alone – to lobby internationally against BDS. In December 2017, the Israeli government announced that another 62.5 million euros would be made available to combat BDS by countering the pressure applied to artists, organising public campaigns, inviting opinion-makers to make ‘solidarity visits’ to Israel and increasing visibility and coordination between pro-Israel groups worldwide. This money will be raised jointly by Israel and a number of Jewish benefactors. Their efforts seems to have worked: the British government has announced that government agencies, including local councils and care facilities, may no longer call for a boycott of Israel. The anti-BDS lobby has also made gains in France, Canada and the United States."
    },
    {
      type: "Paragraph",
      text: "According to Fred Grünfeld, a retired senior lecturer of international relations at Maastricht University and emeritus professor of the causes of human rights violations at Utrecht University, it is exceptional that countries are so active in combating a boycott movement against another country. He can only remember one other example of this when the US passed two laws against the Arab League’s boycott of Israel in the 1970s. The ferocity of the anti-BDS movement in these Western countries, says Grünfeld, could be due to the fear that boycotts of Israel may contribute to anti-Semitism. He points to France, where a number of anti-Semitic incidents have taken place in the last few years, with the country taking fairly strong action against people and organisations who advocate a boycott of Israel."
    },
    {
      type: "Paragraph",
      text: "Israel can certainly use the support of its Western allies, although it is by no means unanimous. The British Labour Party has described the legal thwarting of BDS as an ‘attack on democracy’. Does the call to boycott a country that supresses another people not fall, the party argues, under freedom of speech? Amnesty International believes that government institutions should be free to invest ethically and that they should therefore also have the choice not to divert funds to Israel. Roger Waters, the frontman of Pink Floyd and a prominent BDS activist, said on Radio Canada that it was ‘dangerous’ that the United States and Canada have made ‘a non-violent form of protest against a foreign power’ punishable. ‘I find it a very disturbing thought that a normal human rights organisation, of which I am part, can be turned into an illegal organisation and that I can be imprisoned for my part in it.’"
    },
    {
      type: "Paragraph",
      text: "Paradoxically, the BDS movement benefits from Israeli resistance. Every attack by Prime Minister Netanyahu is a guarantee of publicity. The movement was also far from unhappy with the conference in Israel on how to combat BDS, organised by the widely read daily Yedioth Ahronoth and attended by numerous politicians from both the left and right. The highlight was an appearance by Jewish-American comedienne Roseanne Barr, whom the BDS movement called ‘fascist’."
    },
    {
      type: "Paragraph",
      text: "It is with good reason that Jay Sanderson, president of the Jewish Federation of Greater Los Angeles, warns that Israel should be more cautious in its dealings with BDS. ‘The more money that goes into the fight against BDS,’ Sanderson said in an interview with Haaretz, ‘and the more people make this the big issue of all time, the more fuel we’re giving the other side.’"
    },
    {
      type: "Paragraph",
      text: "According to Fred Grünfeld, the success of the BDS movement depends on hitting Israel hardest where it violates international rights: the illegal settlements in the West Bank. ‘You need to look for measures that specifically target the settlers. If you hit Israel as a whole you will only strengthen the nationalistic counter-movement. And you won’t cultivate any sympathy.’"
    },
    {
      type: "Paragraph",
      text: "Palestinian hardliners will fervently disagree with this particular message from Grünfeld. Within Palestine, it is more or less self-evident that everything Israeli should be boycotted. The BDS movement is so dominant here that any deviation from the norm, real or imagined, can lead to intimidation and threats."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                tablet: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                desktop: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                alt: "",
                text: "The reconstructed part of the Jenin refugee camp, built after 2002."
            },
            {
                mobile: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                tablet: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                desktop: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                alt: "",
                text: "Graffiti covers the new houses, referring to martyrs and their brigades."
            },
            {
                mobile: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                tablet: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                desktop: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                alt: "",
                text: "Street view of the new part of the Jenin refugee camp."
            },
            {
                mobile: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                tablet: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                desktop: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                alt: "",
                text: "Martyr posters of Fatah, Hamas and Islamic Jihad. Written in black it says: 'Brigade Mohammed Asama'."
            },
            {
                mobile: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                tablet: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                desktop: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                alt: "",
                text: "The Jenin refugee camp in 2017."
            },
            {
                mobile: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                tablet: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                desktop: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                alt: "",
                text: "The memorial stone for Ahmad Hassen, who died as a martyr."
            },
            {
                mobile: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                tablet: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                desktop: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                alt: "",
                text: "Street view of the new part of the Jenin refugee camp."
            },
            {
                mobile: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                tablet: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                desktop: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                alt: "",
                text: "Wall proclaiming that all prisoners are heroes, accompanied with names."
            },
            {
                mobile: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                tablet: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                desktop: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                alt: "",
                text: "Street view in the new part of the Jenin refugee camp. 'May the martyrs be forever in heaven,' is written on the wall on the left."
            },
            {
                mobile: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                tablet: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                desktop: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                alt: "",
                text: "Mural with a key and the sea, symbolizing the desire for the return of the refugees in Jenin to present Israel. On the posters, martyrs are commemorated and people are congratulated who have been released from Israeli captivity."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "Is it really the case that the boys in Jenin contributed to normalisation by collaborating with a journalistic production that also included Jewish settlers? You could also argue that the intimidation they experienced threatens press freedom in Palestine, which is already woefully lacking. Palestine ranks 135th, just behind Algeria, in the 2017 World Press Freedom Index compiled by the NGO Reporters Without Borders. Free access to information is not guaranteed to Palestinian reporters. Primarily Fatah supporters in the Gaza Strip and Hamas supporters in the West Bank are regularly intimidated or even physically abused."
    },
    {
      type: "Paragraph",
      text: "Israel does only marginally better, sharing the 91st place with Nicaragua. Reporters Without Borders attributes this ranking in part to military censorship and attacks by Israeli security forces on Palestinian and foreign journalists, mainly during demonstrations."
    },
    {
      type: "Paragraph",
      text: "As the makers of this documentary, we have more often fallen prey to Israeli restrictions: in 2017, reporter Derk Walters was refused a new press card, with its related residence permit, forcing him to end his stay in the region. That we were forced to remove a story from The Holy Road due to Palestinian pressure in 2018 is both a late and equally unpleasant surprise."
    }
]




// WEBPACK FOOTER //
// ./src/data/stories/story7.js